export type QuestionTypeCode = 'MC' | 'SA' | 'ER' | string;

export interface QuestionTag {
  id: string;
  name: string;
}

export interface QuestionProgress {
  last_attempt_at?: string | null;
  last_attempt_was_correct?: boolean | null;
  last_correct_at?: string | null;
  last_incorrect_at?: string | null;
}

export interface QuestionApiModel {
  id: string;
  year: number;
  exam_type: number;
  question_number: number;
  sub_question: string;
  question_type: QuestionTypeCode;
  vce_area_of_study: string;
  question_text: string;
  option_a: string;
  option_b: string;
  option_c: string;
  option_d: string;
  option_e?: string | null;
  correct_answer: string;
  difficulty_rating: number | null;
  marks?: number | null;
  worked_solution?: string | null;
  tags?: QuestionTag[];
  progress?: QuestionProgress | null;
  is_bookmarked?: boolean;
}

export interface QuestionOption {
  key: string;
  text: string;
}

export interface ShortAnswerSubQuestion {
  id: string;
  sub_question: string;
  question_text: string;
  options: QuestionOption[];
  correct_answer: string;
  difficulty_rating: number | null;
  marks?: number | null;
  worked_solution?: string | null;
  progress?: QuestionProgress | null;
  is_bookmarked?: boolean;
}

export interface ShortAnswerQuestionGroup {
  id: string;
  year: number;
  exam_type: number;
  question_number: number;
  question_type: 'SA' | 'ER';
  vce_area_of_study: string;
  difficulty_rating: number | null;
  total_marks?: number | null;
  tags?: QuestionTag[];
  progress?: QuestionProgress | null;
  sub_questions: ShortAnswerSubQuestion[];
}

export const isShortAnswerQuestionGroup = (
  value: unknown
): value is ShortAnswerQuestionGroup => {
  return (
    !!value &&
    typeof value === 'object' &&
    ['SA', 'ER'].includes((value as ShortAnswerQuestionGroup).question_type) &&
    Array.isArray((value as ShortAnswerQuestionGroup).sub_questions)
  );
};
